import { Directive, ElementRef, Renderer2, inject } from '@angular/core';

@Directive({
  selector: 'button[unstyled-button]'
})
export class UnstyledButtonDirective {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  constructor() {
    this.renderer.addClass(this.el.nativeElement, 'unstyled-button');
  }
}